import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { getEnumValue } from 'lib/util/enum';
import Head from 'next/head';
import { TcDirectoryListingProps, TcDirectoryTxTotalsProps } from './_types';
import { getDiseaseTotals } from './_helpers';
import { mapMetadataElements } from 'components/helpers/Head/HeadMeta/MetadataElement';

/**
 * Computes Allogenic total transplants for this center.  Allogenic transplants are
 * comprised of marrow, pbsc, and cord blood transplants.
 * @param {TcDirectoryTxTotalsProps} totals The transplant total record to process.
 */
const getAllogenicTotal = (totals?: TcDirectoryTxTotalsProps): number => {
  if (!totals || !totals.fields) {
    return 0;
  }
  return (
    (totals.fields.marrowTotal?.value ?? 0) +
    (totals.fields.pbscTotal?.value ?? 0) +
    (totals.fields.cordBloodTotal?.value ?? 0)
  );
};

const TCDirectoryMeta = ({ fields, ...props }: TcDirectoryListingProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }
  const programType = fields?.listing ? getEnumValue(fields?.listing.programType) : '';
  const centerName = fields?.centers ? fields?.centers[0]?.fields?.name?.value : '';
  const stateCode = fields?.centers ? getEnumValue(fields?.centers[0]?.fields?.state) : '';
  const city = fields?.centers ? fields?.centers[0]?.fields?.city.value : '';
  const phone = fields?.centers ? fields?.centers[0]?.fields?.phone.value : '';
  const isSurvivalshipProgram =
    fields?.survivorshipPrograms && fields?.survivorshipPrograms?.length > 0 ? '1' : '0';
  const totalAllo = getAllogenicTotal(fields?.totals).toString();
  const diseaseIds = fields?.listing
    ? fields?.listing?.searchableDiseaseIds.value.replace(/\r\n/g, ';')
    : '';
  const listingId = (fields?.listing?.listingId.value ?? 0).toString();
  const diseaseTotalDetails = getDiseaseTotals({ fields, ...props });
  const pageMetaItems = [
    { name: 'nmdp:tcdir:prgm-typ', content: programType },
    { name: 'nmdp:tcdir:ctr:prim:name', content: centerName },
    { name: 'nmdp:tcdir:stcd', content: stateCode },
    { name: 'nmdp:tcdir:ctr:prim:city', content: city },
    { name: 'nmdp:tcdir:ctr:prim:phones', content: phone },
    { name: 'nmdp:tcdir:has-sp', content: isSurvivalshipProgram },
    { name: 'nmdp:tcdir:ttl:allo', content: totalAllo },
    { name: 'tcdir_dis', content: diseaseIds },
    { name: 'nmdp:tcdir:listing', content: listingId },
  ];
  diseaseTotalDetails.forEach((value: number, key: string) => {
    pageMetaItems.push({
      name: `nmdp:tcdir:disease:id:${key}:totals`,
      content: value.toString(),
    });
  });

  return (
    <>
      <Head>{mapMetadataElements({ items: pageMetaItems })}</Head>
    </>
  );
};
export default TCDirectoryMeta;
